import { CommonColors } from "../../../types/colors";
import { GridDensity, GridSpacing } from "./types";

export const gridColumnSpacingsClasses: Record<GridSpacing, string> = {
  [GridSpacing.None]: "gap-x-0",
  [GridSpacing.XS]: "gap-x-1/2 md:gap-x-1",
  [GridSpacing.SM]: "gap-x-1 md:gap-x-2 lg:gap-x-3",
  [GridSpacing.MD]: "gap-x-2 md:gap-x-3 lg:gap-x-5",
  [GridSpacing.LG]: "gap-x-5 md:gap-x-7 lg:gap-x-10",
  [GridSpacing.XL]: "gap-x-8 md:gap-x-12 lg:gap-x-16",
};

export const gridRowSpacingsClasses: Record<GridSpacing, string> = {
  [GridSpacing.None]: "gap-y-0",
  [GridSpacing.XS]: "gap-y-1/2 md:gap-y-1",
  [GridSpacing.SM]: "gap-y-1 md:gap-y-2 lg:gap-y-3",
  [GridSpacing.MD]: "gap-y-2 md:gap-y-3 lg:gap-y-5",
  [GridSpacing.LG]: "gap-y-5 md:gap-y-7 lg:gap-y-10",
  [GridSpacing.XL]: "gap-y-8 md:gap-y-12 lg:gap-y-16",
};

export const paddingClasses: Record<GridSpacing, string> = {
  [GridSpacing.None]: "p-0",
  [GridSpacing.XS]: "p-1/2 md:p-1",
  [GridSpacing.SM]: "p-1 md:p-2 lg:p-3",
  [GridSpacing.MD]: "p-2 md:p-3 lg:p-5",
  [GridSpacing.LG]: "p-5 md:p-7 lg:p-10",
  [GridSpacing.XL]: "p-8 md:p-12 lg:p-16",
};

export const backgroundClasses: Record<CommonColors, string> = {
  [CommonColors.Primary]: "bg-primary",
  [CommonColors.Light]: "bg-light",
  [CommonColors.Neutral]: "bg-neutral",
  [CommonColors.NeutralLight]: "bg-neutral-light",
  [CommonColors.Dark]: "bg-dark",
  [CommonColors.Glass]: "bg-glass",
  [CommonColors.Wood]: "bg-wood",
  [CommonColors.Stone]: "bg-stone",
  [CommonColors.Materia]: "bg-materia",
  [CommonColors.Metal]: "bg-metal",
};

export const gridTemplateColumnClasses: Record<GridDensity, string> = {
  [GridDensity.SINGLE_ELEMENT]: "grid-cols-1",
  [GridDensity.COMPACT]:
    "sm:grid-cols-[repeat(auto-fit,minmax(calc(50%-2px),1fr))] md:grid-cols-[repeat(auto-fit,minmax(calc(33%-4px),1fr))] lg:grid-cols-[repeat(auto-fit,minmax(calc(25%-4px),1fr))] 2xl:grid-cols-[repeat(auto-fit,minmax(calc(20%-4px),1fr))]",
  [GridDensity.REGULAR]:
    "md:grid-cols-[repeat(auto-fit,minmax(calc(50%-12px),1fr))] lg:grid-cols-[repeat(auto-fit,minmax(calc(33%-20px),1fr))] 2xl:grid-cols-[repeat(auto-fit,minmax(calc(25%-20px),1fr))]",
  [GridDensity.LARGE]:
    "md:grid-cols-[repeat(auto-fit,minmax(calc(50%-28px),1fr))] 2xl:grid-cols-[repeat(auto-fit,minmax(calc(25%-40px),1fr))] 3xl:grid-cols-[repeat(auto-fit,minmax(calc(20%-40px),1fr))]",
};
